import React, { useMemo } from "react";
import DashboardMrtTable from "./DashboardMrtTable";
import { Box, Typography } from "@mui/material";

const DepartmentSummaryTable = ({ rows = [], isLoading = false, expanded = {}, onExpandedChange, sorting = [], onSortingChange, onPersonClick }) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: "department",
        header: "DEPARTMENT / TEAM / PERSON",
        size: 320,
        Cell: ({ row }) => (
          <Box sx={{ display: "flex", alignItems: "baseline", gap: 1 }}>
            {row.original.type === "member" ? (
              <button
                type="button"
                className="dashboard-person-link"
                onClick={() => onPersonClick?.(row.original, true)}
                style={{ fontSize: "0.85rem", textDecoration: "underline", textUnderlineOffset: "2px" }}
              >
                {row.original.department}
              </button>
            ) : (
              <Typography
                component="span"
                sx={{
                  fontWeight: row.depth === 0 ? 600 : row.depth === 1 ? 600 : 400,
                  color: row.depth === 0 ? "#2563eb" : "#374151",
                  fontSize: "0.85rem",
                }}
              >
                {row.original.department}
              </Typography>
            )}
            {row.original.subLabel && (
              <Typography
                component="span"
                sx={{
                  fontSize: "0.75rem", color: "#5b5b5c"
                }}
              >
                ({row.original.subLabel})
              </Typography>
            )}
          </Box>
        ),
      },
      {
        accessorKey: "assigned",
        header: "ASSIGNED",
        size: 90,
      },
      {
        accessorKey: "wip",
        header: "WIP",
        size: 80,
        Cell: ({ cell }) => (
          <Typography sx={{ fontWeight: 600, fontSize: "0.85rem" }}>
            {cell.getValue()}
          </Typography>
        ),
      },
      {
        accessorKey: "completed",
        header: "COMPLETED",
        size: 100,
        Cell: ({ cell }) => (
          <Typography sx={{ fontWeight: 600, fontSize: "0.85rem" }}>
            {cell.getValue()}
          </Typography>
        ),
      },
      {
        accessorKey: "overdue",
        header: "OVERDUE",
        size: 90,
        Cell: ({ cell }) => (
          <Typography sx={{ fontWeight: 600, fontSize: "0.85rem" }}>
            {cell.getValue()}
          </Typography>
        ),
      },
      {
        accessorKey: "completionPct",
        header: "COMPLETION %",
        size: 110,
        Cell: ({ cell }) => `${cell.getValue()}%`,
      },
      {
        accessorKey: "overduePct",
        header: "% OVERDUE",
        size: 100,
        Cell: ({ cell }) => `${cell.getValue()}%`,
      },
      {
        accessorKey: "tatAdherencePct",
        header: "% TAT ADHERENCE",
        size: 140,
        Cell: ({ cell }) => {
          const val = cell.getValue();
          let color = "#374151";
          if (val >= 85) color = "#16a34a"; // Green
          else if (val >= 70) color = "#f59e0b"; // Orange
          else color = "#ef4444"; // Red
          return (
            <Typography sx={{ fontWeight: 600, color, fontSize: "0.85rem" }}>
              {val}%
            </Typography>
          );
        },
      },
      {
        accessorKey: "avgOverdueDays",
        header: "AVG OVERDUE DAYS",
        size: 160,
        Cell: ({ cell }) => `${cell.getValue()}d`,
      },
      {
        accessorKey: "avgHrsPerTask",
        header: "AVG HRS/TASK",
        size: 120,
        Cell: ({ cell }) => `${cell.getValue()}h`,
      },
      {
        accessorKey: "openAgeAvgDays",
        header: "OPEN AGE (AVG DAYS)",
        size: 160,
        Cell: ({ cell }) => (
          <Typography sx={{ fontWeight: 600, fontSize: "0.85rem" }}>
            {cell.getValue()}d
          </Typography>
        ),
      },
    ],
    []
  );

  return (
    <DashboardMrtTable
      columns={columns}
      data={rows}
      isLoading={isLoading}
      emptyMessage="No department summary data available."
      unitName="departments"
      scrollContainer={true}
      enableExpanding={true}
      state={{ expanded, sorting }}
      onExpandedChange={onExpandedChange}
      onSortingChange={onSortingChange}
      getSubRows={(row) => row.subRows}
    />
  );
};

export default DepartmentSummaryTable;
